import {IntFieldLabeledBox} from "../boxes/int-field-labeled-box";
import styled from "styled-components";
import {useEffect, useState} from "react";

export const IntDefaultInput = (
  {
    label,
    placeholder,
    type = 'text',
    textarea = false,
    value,
    onChange = () => {},
    isFocused = false,
    required = false,
    onFocus = () => {},
    innerRef,
    isError = false,
    fieldWidth = '100%',
    preventDefault = false,
    titleTooltip = (<></>)
  }
) => {
  const [focus, setFocus] = useState(isFocused);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value)
  }, [value]);

  return <IntFieldLabeledBox
    label={label}
    placeholder={placeholder}
    isFocused={focus}
    isError={isError || (!localValue && required)}
    style={{width: fieldWidth}}
    isActive={focus || Boolean(localValue)}
    titleTooltip={titleTooltip}
  >
      {
          textarea ?
              <FieldTextarea
                  ref={innerRef}
                  value={localValue}
                  type={type}
                  onFocus={() => {
                      setFocus(true);
                      onFocus(true);
                  }}
                  onBlur={() => {
                      setFocus(false)
                      onFocus(false);
                  }}
                  onInput={(e) => {
                      onChange(e.target.value)

                      if(preventDefault){
                          e.preventDefault()
                      }else{
                          setLocalValue(e.target.value)
                      }
                  } }
              />
              :
              <FieldInput
                  ref={innerRef}
                  value={localValue}
                  type={type}
                  onFocus={() => {
                      setFocus(true);
                      onFocus(true);
                  }}
                  onBlur={() => {
                      setFocus(false)
                      onFocus(false);
                  }}
                  onInput={({target}) => {
                      onChange(target.value)
                      setLocalValue(target.value)
                  } }
              />
      }

  </IntFieldLabeledBox>
}

const FieldInput = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
  display: block;
  width: 100%;
  font-family: inherit;
  font-size: .9rem;
`;

const FieldTextarea = styled.textarea`
  resize: vertical;
  border: none;
  background-color: transparent;
  outline: none;
  display: block;
  width: 100%;
  font-family: inherit;
  font-size: .9rem;
`;